import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { EmailGenerationNS } from '../model/ml.EmailGeneration';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmailService } from '../email.service';
import { scrollToError } from '../../../helpers/scroll-to-error.helper';
import { FormErrorHandler } from '../../../helpers/form-error-handler.helper';

@Component({
    selector: 'app-email-generate-ai',
    templateUrl: "./email-generate-ai.component.html",
    styleUrls: ["./email-generate-ai.component.scss"],
})
export class EmailGenerateAiComponent implements OnInit, OnChanges, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() displayDialog: boolean = false;
    @Input() generationType: EmailGenerationNS.EmailGenerationType = EmailGenerationNS.EmailGenerationTypes.GenerateEmail as any;
    @Output() dialogClose = new EventEmitter<boolean>();
    @Output() emailGenerated = new EventEmitter<{subject: string, body: string}>();

    emailGenerationScenario: EmailGenerationNS.EmailGenerationScenarioModel = EmailGenerationNS.EmailGenerationScenario;
    emailGenerationForm: FormGroup = new FormGroup({});
    isLoadingEmailGenerationScenario: boolean = false;
    tone: EmailGenerationNS.Tone[] = EmailGenerationNS.GenerateEmailTones;
    emailGenerationScenarioResponse: EmailGenerationNS.EmailGenerationScenarioResponse = { subject: '', body: '' };
    emailGenerationTypes = EmailGenerationNS.EmailGenerationTypes;

    formErrorHandler: FormErrorHandler = new FormErrorHandler();
    detailsFormErrors: any = {};

    constructor(
        private fb: FormBuilder,
        private emailService: EmailService
    ){

    }

    ngOnInit(): void {
        this.initGenerateEmailForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.displayDialog?.currentValue) {
            this.displayDialog = changes.displayDialog.currentValue;
        }
    }

    initGenerateEmailForm() {
        this.detailsFormErrors = {};
        this.emailGenerationScenario.header = EmailGenerationNS.EmailGenerationHeader[this.generationType];
        this.emailGenerationScenario.scenarioLable = EmailGenerationNS.EmailGenerationScenarioLabel[this.generationType];
        this.emailGenerationScenario.generationType = this.generationType;

        this.emailGenerationForm = this.fb.group({
            scenario: ["", [Validators.required]],
            tone: [EmailGenerationNS.GenerateEmailTones.find(x => x.name == 'Professional'), [Validators.required]],
        });

        this.formErrorHandler.handleErrors(this.emailGenerationForm, this.detailsFormErrors, {
            scenario: {
                required: "Enter Email Scenario",
            }
        });

    }

    getGenerateEmail(): void {
        if (this.emailGenerationForm.invalid) {
            this.formErrorHandler.showErrorOnSubmit();
            scrollToError();
            return; //Return if form invalid
        }
        this.isLoadingEmailGenerationScenario = true;
        this.emailGenerationScenario.recipients = [];

        const tone = this.emailGenerationForm.value.tone;
        const scenario = this.emailGenerationForm.value.scenario;

        const emailGenerationScenarioReq: EmailGenerationNS.EmailGenerationScenarioRequest = {
            maxLength: this.emailGenerationScenario.maxLength,
            signature: this.emailGenerationScenario.signature,
            recipients: this.emailGenerationScenario.recipients,
            tone: tone ? tone.name : this.emailGenerationScenario.tone.name,
            scenario: scenario ?? this.emailGenerationScenario.scenario,
        }
        if (this.emailGenerationScenario.generationType == EmailGenerationNS.EmailGenerationTypes.GenerateEmail) {
            this.emailService.getGenerateEmail(emailGenerationScenarioReq).subscribe((res: any) => {
                this.isLoadingEmailGenerationScenario = false;
                this.emailGenerationScenarioResponse = res;
                this.emailGenerationScenarioResponse.body = this.emailGenerationScenarioResponse?.body?.replace(/\n/gi, "<br>") ?? "";
                this.emailGenerated.emit(this.emailGenerationScenarioResponse);
                this.onDialogClose();
            });
        }
    }

    onDialogClose(): void {
        this.emailGenerationScenario.scenario = '';
        this.emailGenerationScenario.recipients = [];
        this.isLoadingEmailGenerationScenario = false;
        this.displayDialog = false;
        this.dialogClose.emit(true);
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

}
